
import {UploadFileEntry} from './uploadfileentry.model';
export class PacsOfPatient{
	constructor(
        public p_id?:string,
        public filelist?:UploadFileEntry[],
        ){}
	
}